export const IMPERIAL_ACTIONS = {
  SET_WIDTH_FRACTION: "set_width_fractions",
  SET_HEIGHT_FRACTION: "set_height_fractions",
  SET_DEPTH_FRACTION: "set_depth_fractions",
  SET_WIDTH_INTEGER: "set_width_integer",
  SET_HEIGHT_INTEGER: "set_height_integer",
  SET_DEPTH_INTEGER: "set_depth_integer",
  SET_WIDTH_CM: "set_width_cm",
  SET_DEPTH_CM: "set_depth_cm",
  SET_HEIGHT_CM: "set_height_cm",
};

// action handlers

const setWidthFraction = (fraction, state) => {
  return { ...state, width_fraction: fraction };
};

const setDepthFraction = (fraction, state) => {
  return { ...state, depth_fraction: fraction };
};

const setHeightFraction = (fraction, state) => {
  return { ...state, height_fraction: fraction };
};

const setWidthInteger = (value, state) => {
  return { ...state, width_integer: Math.round(value) };
};

const setDepthInteger = (value, state) => {
  return { ...state, depth_integer: Math.round(value) };
};

const setHeightInteger = (value, state) => {
  return { ...state, height_integer: Math.round(value) };
};

const setWidthInCm = (value, state) => {
  return {
    ...state,
    widthCm: value,
  };
};

const setDepthInCm = (value, state) => {
  return {
    ...state,
    depthCm: value,
  };
};

const setHeightInCm = (value, state) => {
  return {
    ...state,
    heightCm: value,
  };
};

export const imperialReducer = (state, action) => {
  switch (action.type) {
    case IMPERIAL_ACTIONS.SET_WIDTH_FRACTION:
      return setWidthFraction(action.fraction, state);
    case IMPERIAL_ACTIONS.SET_DEPTH_FRACTION:
      return setDepthFraction(action.fraction, state);
    case IMPERIAL_ACTIONS.SET_HEIGHT_FRACTION:
      return setHeightFraction(action.fraction, state);
    case IMPERIAL_ACTIONS.SET_WIDTH_INTEGER:
      return setWidthInteger(action.value, state);
    case IMPERIAL_ACTIONS.SET_DEPTH_INTEGER:
      return setDepthInteger(action.value, state);
    case IMPERIAL_ACTIONS.SET_HEIGHT_INTEGER:
      return setHeightInteger(action.value, state);
    case IMPERIAL_ACTIONS.SET_WIDTH_CM:
      return setWidthInCm(action.value, state);
    case IMPERIAL_ACTIONS.SET_DEPTH_CM:
      return setDepthInCm(action.value, state);
    case IMPERIAL_ACTIONS.SET_HEIGHT_CM:
      return setHeightInCm(action.value, state);
    default:
      return state;
  }
};
